import store from '@/store';
export default {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: '主键id',
      prop: 'id',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      search: true,
      searchOrder: 995,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      type: 'input',
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      dicData: store.getters.porductTypes,
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'select',
      search: true,
      searchMultiple: true,
      searchOrder: 999,
      hide: true,
      showColumn: false,
      dicData: store.getters.porductTypes,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 998,
    },
    {
      label: '手机号',
      prop: 'phoneNumber',
      type: 'input',
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'input',
    },
    {
      label: '每月租金',
      prop: 'lendingAmountPer',
      type: 'input',
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
      search: true,
      searchOrder: 997,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    // {
    //   label: "状态",
    //   prop: "processStatusList",
    //   formatter: (val, value, label) => {
    //     return value.map(one => {
    //       if (one.type === 1) {
    //         return (one.process ? "已" : "待") + "办理过户"
    //       } else {
    //         return (one.process ? "已" : "待") + "办理解押"
    //       }
    //     }).join("，")
    //   },
    // },
    // {
    //     label: "过户状态",
    //     prop: "transferOwnershipStatus",
    //     formatter: (val, value, label) => {
    //         return (value ? "已" : "待") + "过户"
    //     },
    // },
    // {
    //     label: "解压状态",
    //     prop: "decompressionStatus",
    //     formatter: (val, value, label) => {
    //         return (value ? "已" : "待") + "解压"
    //     },
    // },
    {
      label: '状态',
      prop: 'decompressTransferStatus',
      formatter: (val, value, label) => {
        if (value === 1) {
          return '待办理过户，待办理解押';
        } else if (value === 2) {
          return '待办理过户，已办理解押';
        } else if (value === 3) {
          return '已办理过户，待办理解押';
        } else if (value === 4) {
          return '待办理解押';
        } else if (value === 5) {
          return '已办理解押';
        } else if (value === 6) {
          return '已办理过户，已办理解押';
        } else {
          return '-';
        }
      },
    },
    {
      label: '办理类型',
      prop: 'sectionStatus',
      type: 'select',
      hide: true,
      searchOrder: 996,
      search: true,
      dicData: [
        {
          label: '待办理过户',
          value: 1,
        },
        {
          label: '待办理解押',
          value: 2,
        },
        {
          label: '已办理过户',
          value: 3,
        },
        {
          label: '已办理解押',
          value: 4,
        },
      ],
    },
    {
      label: '还租日期',
      prop: 'currentLendingDate',
      type: 'date',
      hide: true,
      searchRange: true,
      searchType: 'daterange',
      valueFormat: 'yyyy-MM-dd',
    },
  ],
};
